import { HTMLString } from 'shared/types/html-string'

export type FieldErrorAndDescriptionProps = {
  description?: React.ReactNode
  descriptionClassName?: string
  error?: HTMLString | string | null
  errorClassName?: string
  className?: string
  dataTestIdError?: string
  dataTestIdDescription?: string
}

export const FieldErrorAndDescription = ({
  description,
  descriptionClassName,
  error,
  errorClassName,
  className,
  dataTestIdError,
  dataTestIdDescription,
}: FieldErrorAndDescriptionProps) =>
  error || description ? (
    <div className={className}>
      {description ? (
        <span
          className={`primary-link-container text-sm opacity-70 ${descriptionClassName || ''}`}
          data-test-id={dataTestIdDescription}
        >
          {description}
        </span>
      ) : null}
      {error ? (
        <p
          className={`primary-link-container text-danger text-sm ${errorClassName || ''}`}
          dangerouslySetInnerHTML={{ __html: error }}
          data-test-id={dataTestIdError}
        />
      ) : null}
    </div>
  ) : null
